import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "email-wrap bookmark-wrap" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body x" }
const _hoisted_7 = { class: "product-table" }
const _hoisted_8 = { class: "mb-3 row justify-content-between align-items-center" }
const _hoisted_9 = { class: "col-sm-6 col-md-4" }
const _hoisted_10 = { class: "search-box" }
const _hoisted_11 = { class: "col-sm-auto d-flex gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_13 = {
  key: 1,
  class: "table table-bordered table-hover"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_17 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_18 = ["onClick", "disabled"]
const _hoisted_19 = {
  key: 0,
  class: "badge bg-light text-dark ms-1"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = { class: "dropdown" }
const _hoisted_23 = ["id"]
const _hoisted_24 = ["aria-labelledby"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = { class: "pagination mb-0" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_38 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-body text-center" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "modal-footer" }
const _hoisted_43 = ["href"]
const _hoisted_44 = {
  key: 2,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_45 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-body" }
const _hoisted_48 = {
  key: 0,
  class: "text-center py-5 text-muted"
}
const _hoisted_49 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_50 = { class: "table table-bordered table-hover" }
const _hoisted_51 = { class: "fw-bold" }
const _hoisted_52 = { class: "mt-3 p-3 bg-light rounded" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-3 text-black" }
const _hoisted_55 = { class: "col-md-3 text-black" }
const _hoisted_56 = { class: "badge bg-success ms-1" }
const _hoisted_57 = { class: "col-md-3 text-black" }
const _hoisted_58 = { class: "badge bg-warning ms-1" }
const _hoisted_59 = { class: "col-md-3 text-black" }
const _hoisted_60 = { class: "badge bg-danger ms-1" }
const _hoisted_61 = { class: "row mt-2" }
const _hoisted_62 = { class: "col-md-6 text-black" }
const _hoisted_63 = { class: "col-md-6 text-black" }

import { ref, onMounted, defineAsyncComponent, computed } from "vue";
import * as XLSX from 'xlsx';
import { fetchGetApi, fetchDeleteApi } from '@/util/api';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import Swal from "sweetalert2";

interface PastAdvanceRequest {
    _id: string;
    advanceAmount: number;
    advanceDate: string;
    advanceStatus: string;
    advanceReason: string;
    createdAt: string;
    updatedAt: string;
}

interface AdvanceSalaryRequest {
    _id: string;
    logNo: number;
    date: string;
    employeeName: string;
    empId: string;
    site: string;
    dept: string;
    designation: string;
    daysWorked: string;
    amount: number;
    reason: string;
    guarantor: string;
    guarantorId: string | null;
    guarantorEmpCode: string | null;
    isGuarantorAccepted: boolean;
    advanceFormUrl: string | null;
    autoCheckStatus: string;
    criticalReq: boolean;
    managerName: string;
    pastAdvances6M: string;
    pastAdvanceRequests: PastAdvanceRequest[];
    status: string;
    createdAt: string;
    updatedAt: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'advance-salary-request',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const allData = ref<AdvanceSalaryRequest[]>([]);
const elementsPerPage = ref(10); // Changed to 10 for better UX
const currentPage = ref(1);
const filterQuery = ref("");
const toast = useToast();
const isLoading = ref(false);
const showModal = ref(false);
const selectedItem = ref<AdvanceSalaryRequest | null>(null);
const showImageModal = ref(false);
const selectedImageUrl = ref<string | null>(null);
const showPastAdvancesModal = ref(false);
const selectedPastAdvances = ref<any[]>([]);

const ModalCode = defineAsyncComponent(() => import("@/pages/operation/modal/editAdvanceSalary.vue"));

const getAllData = async () => {
    isLoading.value = true;
    try {
        const response = await fetchGetApi(`api/advance/salary/get/all`);
        allData.value = response.data.data;
    } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch data. Please try again later.");
    } finally {
        isLoading.value = false;
    }
}

onMounted(async () => {
    await getAllData();
});

const downloadExcel = () => {
    try {
        toast.info('Downloading Excel...');
        const worksheet = XLSX.utils.json_to_sheet(allData.value);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Advance Salary Requests");
        XLSX.writeFile(workbook, 'advance_salary_requests.xlsx');
        toast.success('Excel file downloaded successfully');
    } catch (error) {
        toast.error('Failed to download Excel file');
    }
}

const filteredData = computed(() => {
    const query = filterQuery.value.toLowerCase();
    return allData.value.filter(item =>
        item.employeeName.toLowerCase().includes(query) ||
        item.empId.toLowerCase().includes(query) ||
        item.site.toLowerCase().includes(query) ||
        item.reason.toLowerCase().includes(query) ||
        item.status.toLowerCase().includes(query)
    );
});

const num_pages = computed(() => {
    return Math.ceil(filteredData.value.length / elementsPerPage.value);
});

const change_page = (page: number) => {
    currentPage.value = page;
}

const previousPage = () => {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

const nextPage = () => {
    if (currentPage.value < num_pages.value) {
        currentPage.value++;
    }
}

const paginatedData = computed(() => {
    const start = (currentPage.value - 1) * elementsPerPage.value;
    const end = start + elementsPerPage.value;
    return filteredData.value.slice(start, end);
});

const approveRequest = async (item: AdvanceSalaryRequest) => {
    try {
        toast.info('Approving request...');
        await fetchGetApi(`api/advance/salary/approve/${item._id}`);
        await getAllData();
        toast.success('Request approved successfully');

    } catch (error) {
        console.error('Error approving request:', error);
        toast.error('Failed to approve request');
    }
}

const deleteRequest = async (item: AdvanceSalaryRequest) => {
    try {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            toast.info('Deleting request...');
            await fetchDeleteApi(`api/advance/salary/delete/${item._id}`);
            await getAllData();
            toast.success('Request deleted successfully');
        }
    } catch (error) {
        toast.error('Failed to delete request');
    }
}

const rejectRequest = async (item: AdvanceSalaryRequest) => {
    try {
        toast.info('Rejecting request...');
        await fetchGetApi(`api/advance/salary/reject/${item._id}`);
        await getAllData();
        toast.success('Request rejected successfully');
    } catch (error) {
        toast.error('Failed to reject request');
    }
}

const modifyRequest = async (item: AdvanceSalaryRequest) => {
    selectedItem.value = item;
    showModal.value = true;
}

const handleAction = async (action: string, item: AdvanceSalaryRequest) => {
    try {
        // Implement action handlers
        switch(action) {
            case 'approve':
                await approveRequest(item);
                break;
            case 'reject':
                await rejectRequest(item);
                break;
            case 'modify':
                await modifyRequest(item);
                break;
            case 'delete':
                await deleteRequest(item);
                break;
        }
    } catch (error) {
        toast.error('Action failed. Please try again.');
    }
}

const viewImage = (url: string) => {
    selectedImageUrl.value = url;
    showImageModal.value = true;
}

const closeImageModal = () => {
    showImageModal.value = false;
    selectedImageUrl.value = null;
}

const viewPastAdvances = (pastAdvances: any[]) => {
    selectedPastAdvances.value = pastAdvances;
    showPastAdvancesModal.value = true;
}

const closePastAdvancesModal = () => {
    showPastAdvancesModal.value = false;
    selectedPastAdvances.value = [];
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Apps",
      title: "Advance Salary Request"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", {
                          for: "table-complete-search",
                          class: "col-form-label"
                        }, "Search:", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "table-complete-search",
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterQuery).value = $event)),
                          placeholder: "Search by Employee, Emp ID, Site, Reason, or Status"
                        }, null, 512), [
                          [_vModelText, filterQuery.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: "/reports/advance-salary-reports",
                        class: "btn btn-info"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "fa fa-file-text me-2" }, null, -1),
                          _createTextVNode("Reports ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: downloadExcel
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fa fa-download me-2" }, null, -1),
                        _createTextVNode("Download Excel ", -1)
                      ]))])
                    ])
                  ]),
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("div", {
                          class: "spinner-border text-primary",
                          role: "status"
                        }, [
                          _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                        ], -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("table", _hoisted_13, [
                        _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"50px"}
                            }, "Log#"),
                            _createElementVNode("th", { scope: "col" }, "Employee Name"),
                            _createElementVNode("th", { scope: "col" }, "Emp ID"),
                            _createElementVNode("th", { scope: "col" }, "Site"),
                            _createElementVNode("th", { scope: "col" }, "Amount"),
                            _createElementVNode("th", { scope: "col" }, "Date"),
                            _createElementVNode("th", { scope: "col" }, "Reason"),
                            _createElementVNode("th", { scope: "col" }, "Guarantor"),
                            _createElementVNode("th", { scope: "col" }, "Guarantor Status"),
                            _createElementVNode("th", { scope: "col" }, "Auto Check"),
                            _createElementVNode("th", { scope: "col" }, "Critical"),
                            _createElementVNode("th", { scope: "col" }, "Status"),
                            _createElementVNode("th", { scope: "col" }, "Past Advance Track"),
                            _createElementVNode("th", { scope: "col" }, "Provided Image"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item._id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.logNo), 1),
                              _createElementVNode("td", null, _toDisplayString(item.employeeName), 1),
                              _createElementVNode("td", null, _toDisplayString(item.empId), 1),
                              _createElementVNode("td", null, _toDisplayString(item.site), 1),
                              _createElementVNode("td", null, "₹" + _toDisplayString(item.amount.toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(new Date(item.date).toLocaleDateString()), 1),
                              _createElementVNode("td", null, _toDisplayString(item.reason), 1),
                              _createElementVNode("td", null, [
                                (item.guarantor && item.guarantor !== 'N/A')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createElementVNode("strong", null, _toDisplayString(item.guarantor), 1),
                                      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                      _createElementVNode("small", _hoisted_15, _toDisplayString(item.guarantorEmpCode), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_16, "N/A"))
                              ]),
                              _createElementVNode("td", null, [
                                (item.guarantor && item.guarantor !== 'N/A')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(`badge bg-${item.isGuarantorAccepted ? 'success' : 'warning'}`)
                                    }, _toDisplayString(item.isGuarantorAccepted ? 'Accepted' : 'Pending'), 3))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge bg-${item.autoCheckStatus === 'OK' ? 'success' : 'warning'}`)
                                }, _toDisplayString(item.autoCheckStatus), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge bg-${item.isGuarantorAccepted ? 'danger' : 'secondary'}`)
                                }, _toDisplayString(item.isGuarantorAccepted ? 'Yes' : 'No'), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge bg-${item.status === 'Approved' ? 'success' : 
                                                    item.status === 'Rejected' ? 'danger' : 'warning'}`)
                                }, _toDisplayString(item.status), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (viewPastAdvances(item.pastAdvanceRequests)),
                                  class: "btn btn-sm btn-primary",
                                  disabled: !item.pastAdvanceRequests || item.pastAdvanceRequests.length === 0
                                }, [
                                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-history me-1" }, null, -1)),
                                  _cache[11] || (_cache[11] = _createTextVNode("View History ", -1)),
                                  (item.pastAdvanceRequests && item.pastAdvanceRequests.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.pastAdvanceRequests.length), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_18)
                              ]),
                              _createElementVNode("td", null, [
                                (item.advanceFormUrl)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (viewImage(item.advanceFormUrl)),
                                      class: "btn btn-sm btn-info"
                                    }, [...(_cache[12] || (_cache[12] = [
                                      _createElementVNode("i", { class: "fa fa-file-image-o me-1" }, null, -1),
                                      _createTextVNode("View ", -1)
                                    ]))], 8, _hoisted_20))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_21, "No Form"))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("button", {
                                    class: "btn btn-primary btn-sm dropdown-toggle",
                                    type: "button",
                                    id: `dropdownMenuButton${item._id}`,
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false"
                                  }, " Actions ", 8, _hoisted_23),
                                  _createElementVNode("ul", {
                                    class: "dropdown-menu",
                                    "aria-labelledby": `dropdownMenuButton${item._id}`
                                  }, [
                                    (item.status !== 'Approved')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (handleAction('approve', item)), ["prevent"])
                                          }, [...(_cache[13] || (_cache[13] = [
                                            _createElementVNode("i", { class: "fa fa-check text-success me-2" }, null, -1),
                                            _createTextVNode("Approve ", -1)
                                          ]))], 8, _hoisted_26)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.status !== 'Rejected' && item.status !== 'Approved')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (handleAction('reject', item)), ["prevent"])
                                          }, [...(_cache[14] || (_cache[14] = [
                                            _createElementVNode("i", { class: "fa fa-times text-danger me-2" }, null, -1),
                                            _createTextVNode("Reject ", -1)
                                          ]))], 8, _hoisted_28)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.status !== 'Approved')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (handleAction('modify', item)), ["prevent"])
                                          }, [...(_cache[15] || (_cache[15] = [
                                            _createElementVNode("i", { class: "fa fa-edit text-warning me-2" }, null, -1),
                                            _createTextVNode("Modify ", -1)
                                          ]))], 8, _hoisted_30)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _cache[17] || (_cache[17] = _createElementVNode("li", null, [
                                      _createElementVNode("hr", { class: "dropdown-divider" })
                                    ], -1)),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item text-danger",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (handleAction('delete', item)), ["prevent"])
                                      }, [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fa fa-trash me-2" }, null, -1),
                                        _createTextVNode("Delete ", -1)
                                      ]))], 8, _hoisted_31)
                                    ])
                                  ], 8, _hoisted_24)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (paginatedData.value.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("td", {
                                  colspan: "16",
                                  class: "text-center"
                                }, "No records found.", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, " Showing " + _toDisplayString(((currentPage.value - 1) * elementsPerPage.value) + 1) + " to " + _toDisplayString(Math.min(currentPage.value * elementsPerPage.value, filteredData.value.length)) + " of " + _toDisplayString(filteredData.value.length) + " entries ", 1),
                    _createElementVNode("ul", _hoisted_35, [
                      _createElementVNode("li", {
                        class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }]),
                        onClick: previousPage
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                        }, "Previous")
                      ], 2),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(num_pages.value, (i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["page-item", { active: i === currentPage.value }]),
                          key: i,
                          onClick: ($event: any) => (change_page(i))
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                          }, _toDisplayString(i), 1)
                        ], 10, _hoisted_36))
                      }), 128)),
                      _createElementVNode("li", {
                        class: _normalizeClass(["page-item", { disabled: currentPage.value === num_pages.value }]),
                        onClick: nextPage
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                        }, "Next")
                      ], 2)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(ModalCode), {
          key: 0,
          show: showModal.value,
          item: selectedItem.value,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showModal.value = false)),
          onRefreshData: getAllData
        }, null, 8, ["show", "item"]))
      : _createCommentVNode("", true),
    (showImageModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[20] || (_cache[20] = _createElementVNode("h5", { class: "modal-title" }, "Advance Salary Form", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeImageModal
                })
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("img", {
                  src: selectedImageUrl.value || '',
                  alt: "Advance Form",
                  class: "img-fluid",
                  style: {"max-height":"70vh","width":"auto"}
                }, null, 8, _hoisted_41)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("a", {
                  href: selectedImageUrl.value || '#',
                  target: "_blank",
                  class: "btn btn-primary"
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "fa fa-external-link me-2" }, null, -1),
                  _createTextVNode("Open in New Tab ", -1)
                ]))], 8, _hoisted_43),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeImageModal
                }, "Close")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showPastAdvancesModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", { class: "modal-header bg-primary text-white" }, [
                _cache[22] || (_cache[22] = _createElementVNode("h5", { class: "modal-title" }, [
                  _createElementVNode("i", { class: "fa fa-history me-2" }),
                  _createTextVNode("Past Advance Requests History ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: closePastAdvancesModal
                })
              ]),
              _createElementVNode("div", _hoisted_47, [
                (selectedPastAdvances.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("i", { class: "fa fa-inbox fa-3x mb-3" }, null, -1),
                      _createElementVNode("p", null, "No past advance requests found.", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("table", _hoisted_50, [
                        _cache[24] || (_cache[24] = _createElementVNode("thead", { class: "table-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"50px"}
                            }, "#"),
                            _createElementVNode("th", { scope: "col" }, "Date"),
                            _createElementVNode("th", { scope: "col" }, "Amount"),
                            _createElementVNode("th", { scope: "col" }, "Reason"),
                            _createElementVNode("th", { scope: "col" }, "Status"),
                            _createElementVNode("th", { scope: "col" }, "Created At")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPastAdvances.value, (advance, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: advance._id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", null, _toDisplayString(new Date(advance.advanceDate).toLocaleDateString()), 1),
                              _createElementVNode("td", _hoisted_51, "₹" + _toDisplayString(advance.advanceAmount.toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(advance.advanceReason), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge bg-${
                                            advance.advanceStatus === 'Approved' ? 'success' : 
                                            advance.advanceStatus === 'Rejected' ? 'danger' : 'warning'
                                        }`)
                                }, _toDisplayString(advance.advanceStatus), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("small", null, _toDisplayString(new Date(advance.createdAt).toLocaleString()), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "mb-2 text-black" }, "Summary:", -1)),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Total Requests:", -1)),
                            _createTextVNode(" " + _toDisplayString(selectedPastAdvances.value.length), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Approved:", -1)),
                            _createElementVNode("span", _hoisted_56, _toDisplayString(selectedPastAdvances.value.filter(a => a.advanceStatus === 'Approved').length), 1)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Pending:", -1)),
                            _createElementVNode("span", _hoisted_58, _toDisplayString(selectedPastAdvances.value.filter(a => a.advanceStatus === 'Pending').length), 1)
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Rejected:", -1)),
                            _createElementVNode("span", _hoisted_60, _toDisplayString(selectedPastAdvances.value.filter(a => a.advanceStatus === 'Rejected').length), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _cache[29] || (_cache[29] = _createElementVNode("strong", null, "Total Amount Requested:", -1)),
                            _createTextVNode(" ₹" + _toDisplayString(selectedPastAdvances.value.reduce((sum, a) => sum + a.advanceAmount, 0).toLocaleString()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Total Approved Amount:", -1)),
                            _createTextVNode(" ₹" + _toDisplayString(selectedPastAdvances.value.filter(a => a.advanceStatus === 'Approved')
                                        .reduce((sum, a) => sum + a.advanceAmount, 0).toLocaleString()), 1)
                          ])
                        ])
                      ])
                    ]))
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closePastAdvancesModal
                }, "Close")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})